import { render, staticRenderFns } from "./PersonTransactionProfileDetails.vue?vue&type=template&id=7e2598d0&scoped=true&"
import script from "./PersonTransactionProfileDetails.vue?vue&type=script&lang=js&"
export * from "./PersonTransactionProfileDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonTransactionProfileDetails.vue?vue&type=style&index=0&id=7e2598d0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2598d0",
  null
  
)

export default component.exports